export const VEHICLE_MODELS: Record<string, string[]> = {
  Renault: ["Clio", "Symbol", "Mégane", "Captur", "Kadjar", "Koleos", "Kangoo", "Master", "Trafic", "Scénic", "Fluence", "Talisman", "Twingo"],
  Dacia: ["Logan", "Sandero", "Stepway", "Duster", "Lodgy", "Dokker", "Jogger"],
  Peugeot: ["208", "2008", "301", "308", "3008", "408", "508", "5008", "206", "207", "Partner", "Expert", "Boxer"],
  Citroën: ["C3", "C4", "C-Elysée", "C5 Aircross", "Berlingo", "Jumpy", "Jumper", "C4 Picasso"],
  Volkswagen: ["Golf", "Polo", "Passat", "Tiguan", "Touareg", "Jetta", "Caddy", "Amarok", "T-Roc", "Transporter"],
  Seat: ["Ibiza", "Leon", "Arona", "Ateca", "Tarraco"],
  Skoda: ["Fabia", "Octavia", "Superb", "Kodiaq", "Karoq", "Rapid"],
  Hyundai: ["i10", "i20", "Accent", "Elantra", "Tucson", "Santa Fe", "Creta", "Grand i10", "H1", "H100"],
  Kia: ["Picanto", "Rio", "Cerato", "Sportage", "Sorento", "Seltos", "K2700"],
  Toyota: ["Yaris", "Corolla", "Hilux", "Land Cruiser", "RAV4", "Prado", "Fortuner", "Hiace"],
  Nissan: ["Micra", "Sunny", "Qashqai", "X-Trail", "Navara", "Juke"],
  Suzuki: ["Alto", "Celerio", "Swift", "Dzire", "Vitara", "Jimny", "Baleno"],
  Chevrolet: ["Spark", "Aveo", "Sail", "Optra", "Cruze", "Captiva"],
  Fiat: ["Tipo", "Doblo", "Panda", "500", "Ducato", "Fiorino", "Punto"],
  Ford: ["Fiesta", "Focus", "Kuga", "Ranger", "Transit", "EcoSport"],
  "Mercedes-Benz": ["Classe A", "Classe C", "Classe E", "GLA", "GLC", "Sprinter", "Vito"],
  BMW: ["Série 1", "Série 3", "Série 5", "X1", "X3", "X5"],
  Audi: ["A3", "A4", "A6", "Q3", "Q5", "Q7"],
  Opel: ["Corsa", "Astra", "Insignia", "Mokka", "Combo"],
  Mitsubishi: ["L200", "Pajero", "ASX", "Outlander", "Lancer"],
  Mazda: ["2", "3", "6", "CX-3", "CX-5"],
  Honda: ["Civic", "Jazz", "CR-V", "HR-V"],
  Jeep: ["Renegade", "Compass", "Wrangler", "Grand Cherokee"],
  Isuzu: ["D-Max", "NPR"],
  Chery: ["Tiggo 2", "Tiggo 4", "Tiggo 7", "Tiggo 8", "Arrizo 5"],
  Geely: ["Coolray", "Emgrand", "GX3"],
  MG: ["MG ZS", "MG 5", "MG HS", "MG RX5"],
  DFSK: ["Glory 500", "Glory 580", "K01"],
  BAIC: ["X35", "X55", "BJ40"],
  "Great Wall": ["Wingle", "Poer"],
};

export const VEHICLE_BRANDS = Object.keys(VEHICLE_MODELS).sort((a, b) => a.localeCompare(b, "fr"));
